<template>
  <div v-loading="loading" :class="['w-full','mb-4',isTaskDetail ? 'h-full' : '']">
    <div :class="['three-column-layout', isTaskDetail ? '' : 'mb-0']">
      <div class="info-card-title">
        任务种类
      </div>
      <el-row class="three-column-info-list">
        <el-col :span="8" class="item">
          <div class="label">
            任务类型
          </div>
          <div class="value">
            {{ info?.tempName }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            适配职位
          </div>
          <div class="value">
            {{ info?.positionName }}
          </div>
        </el-col>
        <el-col :span="16" class="item">
          <div class="label">
            任务模块说明
          </div>
          <div class="value">
            {{ info?.tempDescription }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div :class="['three-column-layout', isTaskDetail ? '' : 'mb-0']">
      <div class="info-card-title">
        任务信息
      </div>
      <el-row class="three-column-info-list">
        <el-col :span="8" class="item">
          <div class="label">
            服务主体
          </div>
          <div class="value">
            {{ info?.serverName }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            开票科目
          </div>
          <div class="value">
            {{ info?.invoiceSubName }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            任务佣金
          </div>
          <div class="value">
            {{ info?. dutyCommission }}{{ info?. dutyCommission?' 元/单人单月':'' }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            开票种类
          </div>
          <div class="value">
            {{ invoiceTypeLabel[info?.invoiceType] }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            任务时间
          </div>
          <div class="value">
            {{ info?.startTime }} ~ {{ info?.endTime }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label ">
            任务需求人数
          </div>
          <div class="value">
            {{ info?.jobNum }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            任务名称
          </div>
          <div class="value">
            {{ info?.dutyName }}
          </div>
        </el-col>
        <el-col :span="8" class="item" />
        <el-col :span="16" class="item">
          <div class="label">
            任务内容说明
          </div>
          <div class="value">
            {{ info?.description }}
          </div>
        </el-col>
        <el-col :span="16" class="item">
          <div class="label">
            项目附件
          </div>
          <div class="value">
            <div class="value !block">
              <div
                v-for="(v, idx) in info?.attachment"
                :key="idx"
                class="flex align-items-center !gap-[6px]"
              >
                <div class="flex justify-between items-center  cursor-pointer text-[var(--color-text-primary)] text-sm h-[30px]">
                  <div class="flex h-full items-center">
                    <svg-icon class="file-icon mr-2 !w-4 !h-4 text-[var(--color-text-tips)]" icon="ph:file-text" />
                    <div class="w-[200px] truncate">
                      {{ v?.fileName }}
                    </div>
                  </div>
                  <div class="flex h-full items-center">
                    <svg-icon class="file-icon main-primary-text mx-2  !w-4 !h-4" icon="tabler:arrow-bar-to-down" @click="downloadFileC(v)" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div :class="['three-column-layout', isTaskDetail ? '' : 'mb-0']">
      <div class="info-card-title">
        岗位要求
      </div>
      <el-row class="three-column-info-list">
        <el-col :span="8" class="item">
          <div class="label">
            学历要求
          </div>
          <div class="value">
            {{ educationalLabel[info?.educational] }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            酬劳方式
          </div>
          <div class="value">
            {{
              info?.remunerationType === ERenumerationType?.Negotiable
                ? remunerationTypeLabel[ERenumerationType?.Negotiable]
                : info?.remunerationType === ERenumerationType?.FixedAmount
                  ? `${info?.startAmount}元/人`
                  : `${info?.startAmount}元/人 - ${info?.endAmount}元/人`
            }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            性别要求
          </div>
          <div class="value">
            {{ genderLabel[info?.sex] }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            任务地点
          </div>
          <div class="value">
            {{
              info?.dutyAddressType === EDutyAddressType?.Nationwide
                ? dutyAddressTypeLabel[EDutyAddressType?.Nationwide]
                : info?.dutyAddressType === EDutyAddressType?.Online
                  ? dutyAddressTypeLabel[EDutyAddressType?.Online]
                  : info?.dutyAddress
            }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            年龄要求
          </div>
          <div class="value">
            {{
              info?.age === EAgeRequirement?.Unlimited
                ? ageLabel[EAgeRequirement?.Unlimited]
                : `${info?.startAge}岁 - ${info?.endAge}岁`
            }}
          </div>
        </el-col>
      </el-row>
    </div>
    <div :class="['three-column-layout', isTaskDetail ? '' : 'mb-0']">
      <div class="info-card-title">
        任务限制
      </div>
      <el-row class="three-column-info-list">
        <el-col :span="8" class="item">
          <div class="label ">
            小程序公开任务
          </div>
          <div class="value">
            {{ publicInMiniLabel[info?.publicInMini] }}
          </div>
        </el-col>
        <el-col :span="8" class="item">
          <div class="label">
            任务报名
          </div>
          <div class="value">
            {{ signUpRequiredLabel[info?.signUpRequired] }}
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script setup lang='ts'>
import { SvgIcon } from '@vue3/components';
import {
  ageLabel,
  dutyAddressTypeLabel,
  EAgeRequirement,
  educationalLabel,
  EDutyAddressType,
  ERenumerationType,
  genderLabel,
  ITaskDetail,
  remunerationTypeLabel,
  invoiceTypeLabel,
  signUpRequiredLabel,
  publicInMiniLabel,
} from '@core/main/types/crowd-source/task';
import { computed, ref } from 'vue';
import { queryTaskDetail } from '@core/main/api/crowd-source/task';
import { ElMessage } from 'element-plus';
import { downloadLinkFile } from '@core/api';
import { useRoute } from 'vue-router';

const props = defineProps({
  id: {
    type: String,
    default: undefined,
  },
  refresh: {
    type: Number,
    default: undefined,
  },
});

const route = useRoute();

const info = ref<ITaskDetail>({} as ITaskDetail);
const loading = ref(false);

const isTaskDetail = computed(() => route?.name === 'BrokerLaborTaskDetail');

/**
 * 查询任务详情
 */
async function getDutyDetail() {
  loading.value = true;
  try {
    if (props?.id) {
      const res = await queryTaskDetail(Number(props?.id), props?.refresh);

      info.value = res.data;
    }
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  } finally {
    loading.value = false;
  }
}

function downloadFileC(file: any) {
  downloadLinkFile(file.fileUrl);
}

getDutyDetail();
</script>
